import { CourseGroupWithCourses } from "../../types";
import { CourseCard } from "./CourseCard";
import TourCardWrapper from "../Tour/TourCardWrapper";
import clsx from "clsx";
import { useState } from "react";
import { GroupedCoursesHeader } from "./GroupedCoursesHeader";

export const GroupedCoursesLanding: React.FC<{
  courseGroups: CourseGroupWithCourses[];
}> = ({ courseGroups }) => {
  const [isWiggling, setIsWiggling] = useState(false);

  return (
    <>
      <GroupedCoursesHeader groups={courseGroups} />

      <TourCardWrapper
        step={5}
        tourType="learner"
        classNames={clsx(
          "flex flex-col gap-10 p-4",
          isWiggling && "onboardingWiggle"
        )}
        allowClick
        forceTop
        onNext={() => {
          // Reset the wiggling animation each time someone clicks
          setIsWiggling(false);
          setTimeout(() => {
            setIsWiggling(true);
          }, 1);
        }}
      >
        {courseGroups.map((group) => (
          <div
            key={group._id}
            className="relative flex flex-col gap-4"
            id={group.name.replace(/\s+/g, "-").toLowerCase()}
            // See GroupedCoursesHeader for details on how these are used
            data-scrollspy
            data-group-id={group._id}
          >
            <header className="max-w-[600px]">
              <h2 className="mb-1 font-serif text-lg font-bold">
                {group.name}
              </h2>
              <p className="text-dm-charcoal-800">{group.description}</p>
            </header>
            <div className="relative grid grid-cols-1 content-stretch justify-stretch gap-4 md:grid-cols-2">
              {group.courses.map((course) => (
                <CourseCard key={course.id} course={course} />
              ))}
            </div>
          </div>
        ))}
      </TourCardWrapper>
    </>
  );
};
